import _ from 'lodash';
import {DICTIONARY} from '../../../dictionary';
import {AccountCompromisedService} from '../../../services/accountCompromisedService';
import {RouteService} from '../../../services/routeService';
import {NotificationService} from '../../../services/notificationService';
import {GeneralService} from '../../../services/generalService';
import {Component, OnInit} from "@angular/core";

@Component({
	selector: 'account-management-component',
	templateUrl: './account-management.component.html',
})
export class AccountManagementComponent implements OnInit {
	loadAccountsInProcess = false;
	dic = DICTIONARY;

	multipleUsersActions = [
		this.dic.CONSTANTS.accountCompromisedUsersActions.enable,
		this.dic.CONSTANTS.accountCompromisedUsersActions.disable
	];

	users;
	filterData;
	accountInfo;
	showAccountInfoPopup = false;

	constructor(private accountCompromisedService:AccountCompromisedService,
				private rs:RouteService,
				private ns:NotificationService,
				public gs:GeneralService) {
	}

	ngOnInit(): void {
		this.initFilters();
		this.getAccountCompromisedUsers();
    }

	getAccountCompromisedUsers = () => {
		this.loadAccountsInProcess = true;
		this.rs.getAccountCompromisedUsers('').then(response => {
			this.users = response;
			this.users = _.map(this.users, user => {
				user.status = user.misc.account_compromised.enabled ? 'enabled' : 'disabled'
				return user;
			});

			this.loadAccountsInProcess = false;
		}, (err) => {
			this.loadAccountsInProcess = false;
		});
	}

	showUserBulkActions = () => {
		return this.multipleUsersActions;
	}

	showMailboxActions = (mailboxObj) => {
		let actions;

		if (mailboxObj.misc.account_compromised.enabled) {
			actions = [this.dic.CONSTANTS.accountCompromisedUsersActions.disable];
		}
		else {
			actions = [this.dic.CONSTANTS.accountCompromisedUsersActions.enable];
		}
		actions.push(
			this.dic.CONSTANTS.accountCompromisedUsersActions.accountInfo,
			this.dic.CONSTANTS.accountCompromisedUsersActions.suspiciousInfo,
			this.dic.CONSTANTS.accountCompromisedIncidentActions.blockUser24hours.display,
			this.dic.CONSTANTS.accountCompromisedIncidentActions.riskyUser24hours.display,
			this.dic.CONSTANTS.accountCompromisedIncidentActions.disableUserMailServer.display,
			this.dic.CONSTANTS.accountCompromisedIncidentActions.resetPasswordMailServer.display,
			this.dic.CONSTANTS.accountCompromisedIncidentActions.removeRestrictions.display
		);

		return actions;
	}

	selectAction = (mailbox, action) => {
		if (!mailbox) {
			return;
		}

		switch (action) {
			case this.dic.CONSTANTS.accountCompromisedUsersActions.enable:
				this.updateStatus([mailbox], true);
				break;

			case this.dic.CONSTANTS.accountCompromisedUsersActions.disable:
				this.updateStatus([mailbox], false);
				break;

			case this.dic.CONSTANTS.accountCompromisedUsersActions.accountInfo:
				this.getAccountCompromisedInfo(mailbox);
				break;

			case this.dic.CONSTANTS.accountCompromisedUsersActions.suspiciousInfo:
				this.accountCompromisedService.showUserIncidentsInfo(mailbox);
				break;

			case this.dic.CONSTANTS.accountCompromisedIncidentActions.blockUser24hours.display:
				this.blockUser24hoursExecute(mailbox);
				break;

			case this.dic.CONSTANTS.accountCompromisedIncidentActions.riskyUser24hours.display:
				this.riskyUser24hoursExecute(mailbox);
				break;

			case this.dic.CONSTANTS.accountCompromisedIncidentActions.disableUserMailServer.display:
				this.disableUserMailServerExecute(mailbox);
				break;

			case this.dic.CONSTANTS.accountCompromisedIncidentActions.resetPasswordMailServer.display:
				this.resetPasswordMailServerExecute(mailbox);
				break;

			case this.dic.CONSTANTS.accountCompromisedIncidentActions.removeRestrictions.display:
				this.removeRestrictionsUser(mailbox);
				break;
		}
	}

	selectMultipleAction = (selectedUsers,action) => {
		switch (action) {
			case this.dic.CONSTANTS.accountCompromisedUsersActions.enable:
				this.updateStatus(selectedUsers, true);
				break;

			case this.dic.CONSTANTS.accountCompromisedUsersActions.disable:
				this.updateStatus(selectedUsers, false);
				break;
		}
	}

	updateStatus(users, enable) {
		const updateData = {
			action: this.dic.CONSTANTS.accountCompromisedUsersActions.status,
			enable: enable,
			emails: _.map(users, 'email')
		};
		this.rs.updateAccountCompromisedUsers(updateData).then(() => {
			_.map(users, u => {
				u.misc.account_compromised.enabled = enable;
				u.status = u.misc.account_compromised.enabled ? 'enabled' : 'disabled'
				u.selected = false;
				return u;
			})
			//this.selectedAll = false;
			//this.toggleAllUsers();
			users.length = 0;
			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);
		});
	}

	blockUser24hoursExecute = (userObj) => {
		this.gs.showPopup({
			title: 'Block User',
			subTitle: `Block User ${userObj.email} - user will not be able to access their account or send emails for 24 hours`,
			body: [],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Confirm',
			doneCb: () => {
				const actionInfo = {
					action: this.dic.CONSTANTS.accountCompromisedIncidentActions.blockUser24hours.display
				};
				this.rs.incidentAction(userObj.email, actionInfo).then(() => {
					this.ns.showInfoMessage(`${userObj.email} blocked for 24 hours successfully`);
				}, (err) => {
				});
			}
		});
	}

	removeRestrictionsUser = (userObj) => {
		this.gs.showPopup({
			title: 'Remove Restrictions for User',
			subTitle: `Remove all restrictions for User ${userObj.email} - user will be unblocked and will not consider as risky`,
			body: [],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Remove Restrictions',
			doneCb: () => {
				const actionInfo = {
					action: this.dic.CONSTANTS.accountCompromisedIncidentActions.removeRestrictions.display
				};
				this.rs.incidentAction(userObj.email, actionInfo).then(() => {
					this.ns.showInfoMessage(`removed restrictions successfully for ${userObj.email}`);
				}, (err) => {
				});
			}
		});
	}

	riskyUser24hoursExecute = (userObj) => {
		this.gs.showPopup({
			title: 'Set User as Risky for 24 Hours',
			subTitle: `For 24 hours, emails sent from this user will undergo an extensive threat scan`,
			body: [],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Confirm',
			doneCb: () => {
				const actionInfo = {
					action: this.dic.CONSTANTS.accountCompromisedIncidentActions.riskyUser24hours.display,
					incidentId: userObj._id
				};
				this.rs.incidentAction(userObj.email, actionInfo).then(() => {
					this.ns.showInfoMessage(`${userObj.email} set as risky successfully`);
				}, (err) => {
				});
			}
		});
	}

	disableUserMailServerExecute = (userObj) => {
		this.gs.showPopup({
			title: 'Disable User Email Account',
			subTitle: `Disable user ${userObj.email}`,
			body: ['User will not be able to login to their email account'],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Confirm',
			doneCb: () => {
				const actionInfo = {
					action: this.dic.CONSTANTS.accountCompromisedIncidentActions.disableUserMailServer.display
				};
				this.rs.incidentAction(userObj.email, actionInfo).then(data => {
					this.ns.showInfoMessage(`${userObj.email} account disabled successfully`);
				}, (err) => {});
			}
		});
	}

	resetPasswordMailServerExecute = (userObj) => {
		this.gs.showPopup({
			title: 'Reset User Email Password',
			subTitle: `Reset password for user ${userObj.email}`,
			body: ['User will have to reset their password on the next login to their email account'],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Confirm',
			doneCb: () => {
				const actionInfo = {
					action: this.dic.CONSTANTS.accountCompromisedIncidentActions.resetPasswordMailServer.display
				};
				this.rs.incidentAction(userObj.email, actionInfo).then(data => {
					this.ns.showInfoMessage(`${userObj.email} password reset successfully. New temporary password: "${data.password}". Change password on next login.`);
				}, (err) => {});
			}
		});
	}

	blockUser = (userObj) => {
		this.gs.showPopup({
			title: 'Block User',
			subTitle: `Block User ${userObj.email} - user will not be able to access their account or send emails`,
			body: [],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Block',
			doneCb: () => {
				const actionInfo = {
					action: this.dic.CONSTANTS.accountCompromisedIncidentActions.blockUser.display
				};
				this.rs.incidentAction(userObj.email, actionInfo).then(() => {
					this.ns.showInfoMessage(`${userObj.email} blocked successfully`);
				}, (err) => {
				});
			}
		});
	}

	initFilters = () => {
		this.filterData = {
			filterType: this.dic.CONSTANTS.tableFilters.accountManagement,
			filters: {
				status: ['enabled', 'disabled']
			},
			initFiltersFunction: this.initFilters
		};
	}

	searchUsers = (event) => {
		this.users.forEach(record => {
			// search
			if (event.searchTerm) {
				const isFound = this.searchTextExecute(record, event.searchTerm);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			// filter
			if (event.activeFilters) {
				// need to match all filter types
				let numFilterToMatch = Object.keys(event.activeFilters).length;

				if (event.activeFilters.status && event.activeFilters.status.length) {
					if (event.activeFilters.status.includes(record.status)) {
						numFilterToMatch--;
					}
				}
				if (numFilterToMatch) {
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	}

	exportToCsv = (sortBy) => {
		if (!this.users || !this.users.length) {
			this.ns.showWarnMessage(this.dic.ERRORS.noDataToExportCsv);
			return;
		}

		let csvString = "Name,Email,Status\n";

		let sortedTable = _.filter(this.users,user => {return !user.hide});
		if (sortBy) {
			sortedTable = this.gs.sortTable(sortedTable, sortBy);
		}

		sortedTable.forEach((user) => {
			csvString += `"${user.name}",${user.email},"${user.status}"\n`;
		});

		this.gs.exportCsv(csvString, `user_management.csv`);
	}

	getAccountCompromisedInfo(user) {
		this.accountInfo = user;
		this.showAccountInfoPopup = true;
	}


	searchTextExecute(userObj, searchTerm) {
		searchTerm = searchTerm.toLowerCase();
		return ((userObj.name?.toLowerCase().indexOf(searchTerm) > -1) ||
			(userObj.email.toLowerCase().indexOf(searchTerm) > -1));
	}
}
